// import React from 'react';
import FaqView from './Faq.view';

/**
 * provider
 */
const FaqContainer = ({ type }) => {
  let hash = window.location.hash;
  if (hash) hash = hash.replace('#', '');

  return <FaqView type={type} app={hash} />;
};

export default FaqContainer;
